import PropTypes from 'prop-types'
import React from 'react'
import TextField from '../../molecules/fields/TextField'
import { HtmlField } from '../../molecules/fields/HtmlField'
import * as validations from '../../../utils/validations'

const InformationBlockField = ({ baseName }) => (
  <div>
    <TextField
      label="Título del bloque"
      size="2xl"
      name={`${baseName}.payload.label`}
      validate={validations.required()}
      margin="none"
      errorClassName="relative inset-0"
      initialValue=""
      capsLockInfo
    />
    <HtmlField
      label="Texto del bloque informativo"
      margin="minimun"
      name={`${baseName}.payload.hint`}
      className="mt-4"
      capsLockInfo
    />
  </div>
)

export default InformationBlockField

InformationBlockField.propTypes = {
  baseName: PropTypes.string
}
